/**
 *
 * Tenant Rules Page constants
 *
 */

export const TENANT_RULE_DATA_TABLE = 'TenantRuleDataTable';

export const HANDLE_PARAMS_ACTION = 'claris-vnext/RulesPage/AdministratorBCView/HANDLE_PARAMS_ACTION';

export const TENANT_RULE_FORM = 'TenantRuleForm';
export const TENANT_RULE_FORM_DIALOG = 'TenantRuleFormDialog';

export const EXECUTE_ADD_ACTION = 'claris-vnext/RulesPage/AdministratorBCView/EXECUTE_ADD_ACTION';
export const EXECUTE_EDIT_ACTION = 'claris-vnext/RulesPage/AdministratorBCView/EXECUTE_EDIT_ACTION';
export const EXECUTE_VIEW_ACTION = 'claris-vnext/RulesPage/AdministratorBCView/EXECUTE_VIEW_ACTION';